// ProductDetail.tsx
import { useContext } from 'react';
import { useState } from 'react';
import { ProductItem } from './ProductItem';
import { DefaultButton } from '../buttons/DefaultButton';
import { putOrderLogisticState } from '../../services/orders/orderAxios';
import { OrderDetailsContext } from '../../context/OrderDetailContext';
import { LogisticState } from '../../types/order/logisticState';
import { Order } from "../../pages/SalesPage/SalesPageInterface";
import { ProductInterface } from "../../pages/OrderDetailsPage/OrderDetailsInterface";
import { dictionary } from '../../utils/dictionary';
import { useAuth } from '../../context/AuthContext';
import { getCurrencySymbol } from '../../utils/formatters';
import { getOrderDisplayCurrencyCode } from '../../utils/orderDisplayTotals';

interface ProductDetailProps {
  order: Order;
  products: ProductInterface[];
}

export const ProductDetail = ({ order, products }: ProductDetailProps) => {
  const { language } = useAuth();
  const context = useContext(OrderDetailsContext);
  const [isLoading, setIsLoading] = useState(false);

  if (!context) return null;

  const { orderDetails: orderDetails, changeOrderFulfillmentState } = context;
  const currencySymbol = getCurrencySymbol(getOrderDisplayCurrencyCode(order));

  const handleOrderStateChange = async (state: LogisticState, hash_id: string | number) => {
    setIsLoading(true);
    const response = await putOrderLogisticState(state, hash_id);
    if (response) {
      const newState = state === LogisticState.IN_PROGRESS ? "fulfilled" : "unfulfilled";
      changeOrderFulfillmentState(newState);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  return (
    <div className="border rounded-lg overflow-hidden mb-6 bg-white">
      <div className="p-4 flex items-center">
        <div className={`h-5 w-5 rounded-full mr-2 ${orderDetails?.logistic_state === "in_progress" ? "bg-blue-200" : "bg-yellow-200"}`}></div>
        <h2 className="font-medium">{orderDetails?.logistic_state === "in_progress" ? dictionary["fulfilled-state"][language] : dictionary["unfulfilled-state"][language]}</h2>
      </div>
      <hr className="border-t border-gray-200" />

      <div className="bg-white">
        {products.map((product) => (
          <ProductItem 
            key={product.id}
            product={product}
            detailId={product.id.toString()}
            currencySymbol={currencySymbol}
          />
        ))}
      </div>

      {(orderDetails?.logistic_state === LogisticState.CREATED || orderDetails?.logistic_state === LogisticState.IN_PROGRESS) && ( 
        <div className="flex justify-end p-4">
          <DefaultButton
            title={orderDetails?.logistic_state === LogisticState.CREATED ? dictionary["fulfill-item"][language] : dictionary["unfulfill-item"][language]}
            onClick={() => handleOrderStateChange(orderDetails?.logistic_state === LogisticState.CREATED ? LogisticState.IN_PROGRESS : LogisticState.CREATED, orderDetails.hash_id)}
            isLoading={isLoading}
          />
        </div>
      )}

    </div>
  );
};
